define('display/layers/vector/configuration',['http', 'endpoints'], function(http, endpoints) {
    'use strict';
    return function(key, mapLayers, resourcesUrls) {
        function createEndpoint(hostName) {
            return http.protocol() + '://' + hostName + '.' + endpoints.vectorLayer + (key ? '?key=' + key : '');
        }

        return {
            minZoom: 2,
            maxZoom: 20,
            renderer: {
                accessToken: 'no-token',
                style: {
                    sources: {
                        vectorTiles: {
                            type: 'vector',
                            tiles: [
                                createEndpoint('a'),
                                createEndpoint('b'),
                                createEndpoint('c'),
                                createEndpoint('d')
                            ]
                        }
                    },
                    glyphs: resourcesUrls.glyphs,
                    sprite: resourcesUrls.sprite,
                    layers: mapLayers,
                    version: 8,
                    transition: {
                        duration: 0,
                        delay: 0
                    }
                }
            }
        };
    };
});

